import {createSlice} from "@reduxjs/toolkit";
import {getHomeNotices} from "redux/actions/app";

export interface IHomeNotice {
  title: string
  author: string
  category: string
  url: string
  created_at: string
}

export interface IHomeNotices {
  homeNotice: IHomeNotice[],
  loading: boolean,
}

const initial: IHomeNotices = {
  homeNotice: [],
  loading: false,
}

export const homeNoticesSlice = createSlice({
  name: "homeNoticesSlice",
  initialState: initial,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomeNotices.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getHomeNotices.fulfilled, (state, action) => {
      state.loading = false;
      state.homeNotice = action.payload;
    });
    builder.addCase(getHomeNotices.rejected, (state, action) => {
      state.loading = false;
    });
  },
});
export default homeNoticesSlice.reducer;